import {
    ExperimentParticipationQueryKey,
    ExperimentParticipationQueryKeyName,
    ExperimentQueryKey,
    ExperimentQueryKeyName,
} from '@data/queries/experiment/types'

export function getExperimentQueryKey(experimentName: TExperimentName): ExperimentQueryKey {
    return [ExperimentQueryKeyName, { experimentName }]
}

export function getExperimentParticipationQueryKey(experimentName: TExperimentName): ExperimentParticipationQueryKey {
    return [ExperimentParticipationQueryKeyName, { experimentName }]
}
